import React from 'react';
import { Link } from 'react-router-dom';
import { mockData } from '../mock';

const Footer = ({ currentLang }) => {
  const t = mockData.translations[currentLang];
  
  return (
    <footer className="bg-black border-t border-white/25 py-16">
      <div className="px-[7.6923%]">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src={mockData.logo.url} 
                alt={mockData.logo.alt}
                className="h-8 w-8"
              />
              <div className="text-2xl font-bold text-white">
                Nusantara <span className="text-[#00FFD1]">Capital.ai</span>
              </div>
            </div>
            <p className="text-white/70 mb-4">
              {mockData.company.tagline}
            </p>
            <p className="text-white/60 text-sm leading-relaxed">
              {mockData.company.address}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-white/70 hover:text-[#00FFD1] transition-colors">
                {t.nav.home}
              </Link>
              <Link to="/about" className="block text-white/70 hover:text-[#00FFD1] transition-colors">
                {t.nav.about}
              </Link>
              <Link to="/services" className="block text-white/70 hover:text-[#00FFD1] transition-colors">
                {t.nav.services}
              </Link>
              <Link to="/investor" className="block text-white/70 hover:text-[#00FFD1] transition-colors">
                {t.nav.investor}
              </Link>
              <Link to="/contact" className="block text-white/70 hover:text-[#00FFD1] transition-colors">
                {t.nav.contact}
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <div className="space-y-2">
              <p className="text-white/70">
                Email: <a href={`mailto:${mockData.company.email}`} className="text-[#00FFD1] hover:underline">
                  {mockData.company.email}
                </a>
              </p>
              <p className="text-white/70">
                WhatsApp: <a href={`https://wa.me/${mockData.company.whatsapp.replace(/[^0-9]/g, '')}`} className="text-[#00FFD1] hover:underline">
                  {mockData.company.whatsapp}
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/25 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © 2025 Nusantara Capital.ai. All rights reserved.
            </p>
            <p className="text-white/50 text-xs">
              Disclaimer: For informational purposes only. Not financial advice.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;